import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logout } from "utils/service";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  getDashboardData,
  selectDashboard,
} from "features/dashboard/dashboardSlice";

function Sidebar() {
  const { data, pending, error } = useAppSelector(selectDashboard);
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState("");
  const [barClass, setBarClass] = useState("fa-bars");
  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location]);

  const toggleSidebar = () => {
    var element = document.getElementById("sidebar");
    if (element) element.classList.toggle("active");
    if (barClass === "fa-bars") setBarClass("fa-xmark");
    else setBarClass("fa-bars");
  };
  const comingSoon = () => {
    toast.warning("Coming Soon!");
  };
  const logoutUser = () => {
    logout();
    toast.success("You have logged out successfully.");
    window.location.href = "login";
  };
  return (
    <div className="right-border mobile-sidebar">
      {/* <div className="d-flex justify-content-start p-2">
            <button type="button" onClick={toggleSidebar} id="sidebarCollapse" className="btn btn-info navbar-btn ">
                <i className={`fa-solid ${barClass}`}></i>
            </button>
             <div className="sidebar-header">
            <h3>VC</h3>
            
            </div>
            </div> */}

      <nav id="sidebar">
        {/* <div className="sidebar-header">
            <h3>Bootstrap Sidebar</h3>
            
            </div> */}

        <ul className="nav nav-pills flex-column mb-auto p-2">
          <li className="nav-item">
            <Link
              to="/dashboard"
              className={`nav-link ${
                currentPage === "/dashboard" ? "active" : "text-white"
              }`}
              aria-current="page"
            >
              <i className="fa fa-home me-2"></i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to="/questions"
              className={`nav-link ${
                currentPage === "/questions" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-question me-2"></i>
              Questions
            </Link>
          </li>
          {/* <li>
            <Link
              to="/downloads"
              className={`nav-link ${
                currentPage === "/downloads" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-download me-2"></i>
              Downloads
            </Link>
          </li> */}
          <li>
            <Link
              to="/coverage"
              className={`nav-link ${
                currentPage === "/coverage" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-wifi me-2"></i>
              Coverage
            </Link>
          </li>
          <li>
            <Link
              to="/demos"
              className={`nav-link ${
                currentPage === "/demos" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-video me-2"></i>
              Videos
            </Link>
          </li>
          <li>
            <Link
              to="/account"
              className={`nav-link ${
                currentPage === "/account" || currentPage === "/profile" || currentPage === "/subscription" || currentPage === "/book-n-pendrive" || currentPage === "/payments" || currentPage === "/add-subscription" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-user-alt me-2"></i>
              Profile/Subscription
            </Link>
          </li>
          {/* <li>
                        <span onClick={comingSoon} className="nav-link text-white">
                            <i className="fas fa-user-alt me-2"></i>
                            Profile/Subscription
                        </span>
                    </li> */}
          {/* <li>
            <span onClick={comingSoon} className="nav-link text-white">
              <i className="far fa-share-alt me-2"></i>
              Share with friends
            </span>
          </li> */}
          <li>
            <Link
              to="/notifications"
              className={`nav-link ${
                currentPage === "/notifications" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-bell me-2"></i>
              Notifications{" "}
              {data?.new_notifications?.length > 0 && (
                <span className="new-badge">New</span>
              )}
            </Link>
          </li>
          <li>
            <Link
              to="/contact-us"
              className={`nav-link ${
                currentPage === "/contact-us" ? "active" : "text-white"
              }`}
            >
              <i className="fas fa-address-book me-2"></i>
              Contact us
            </Link>
          </li>
        </ul>
        <hr />
        <div className="dropdown">
          <div
            onClick={() => logoutUser()}
            className={`nav-link text-white text-start cursor-pointer px-4`}
            aria-current="page"
          >
            {/* <img src="https://github.com/mdo.png" alt="" width="32" height="32"
                            className="rounded-circle me-2" /> */}
            <i className="fas fa-bell me-2"></i>
            <strong>Logout</strong>
          </div>
          <div className="fs-6 mt-3 text-white">
            <small>Copyright@ Verge Infotech</small>
          </div>
        </div>
      </nav>
    </div>
  );
}
export default Sidebar;
